import { Box, Card, styled } from '@mui/material';

export const StepCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(4),
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: '0 4px 20px rgba(22, 63, 101, 0.04)',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'visible',
  [theme.breakpoints.down('sm')]: { padding: theme.spacing(2.5) },
}));

export const StepActions = styled(Box)(({ theme }) => ({
  position: 'sticky',
  bottom: 0,
  zIndex: theme.zIndex.appBar,
  backgroundColor: theme.palette.background.default,
  boxShadow: '0 -4px 12px rgba(22, 63, 101, 0.03)',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(1.5),
  marginTop: theme.spacing(4),
  padding: theme.spacing(2.5, 3),
  paddingBottom: `calc(${theme.spacing(2.5)} + env(safe-area-inset-bottom, 0px))`,
  borderTop: `1px solid ${theme.palette.divider}`,
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    '& > button': { flexGrow: 1 },
  },
}));
